<div class="col-sm-12">
    <div *ngIf="bIsCheckForLOVEntry; else elseCheckForLOVEntry" class="col-sm-12 font-warning icon-align-left">
        <ejs-tooltip #tooltip content="This value is no longer an FDA acceptable term. Please update."
            position="BottomLeft"  [enableHtmlParse]="false" aria-label="This value is no longer an FDA acceptable term. Please update.">
            <span><i class="fas fa-exclamation-triangle"></i>&nbsp;</span>
        </ejs-tooltip>
        <span [attr.aria-label]="name">{{name}}</span>
    </div>
    <ng-template #elseCheckForLOVEntry>
        <div *ngIf="bIsOrder; else elseOrderBlock" class="col-sm-12 font-warning">
            <ejs-tooltip #tooltip content='This user is no longer valid. Please update.' position="BottomLeft"  [enableHtmlParse]="false"
            aria-label="This user is no longer valid. Please update.">
                <span><i class="fas fa-exclamation-triangle"></i>&nbsp;</span>
            </ejs-tooltip>
            <span [attr.aria-label]="name">{{name}}</span>
        </div>
        <ng-template #elseOrderBlock>
            <div *ngIf="type; else elseBlock" class="col-sm-12 font-warning">
                <ejs-tooltip #tooltip  [enableHtmlParse]="false"
                    content='This company is either not the latest version or no longer exists. Please update.'
                    position="BottomLeft"
                    aria-label="This company is either not the latest version or no longer exists. Please update.">
                    <span><i class="fas fa-exclamation-triangle"></i>&nbsp;</span>
                </ejs-tooltip>
                <span [attr.aria-label]="name">{{name}}</span>
            </div>
            <ng-template #elseBlock>
                <div class="col-sm-12 font-warning">
                    <ejs-tooltip #tooltip  [enableHtmlParse]="false"
                        content='This contact is either not the latest version, on Leave of Absence, or no longer exists. Please update.'
                        position="BottomRight"
                        aria-label="This contact is either not the latest version, on Leave of Absence, or no longer exists. Please update.">
                        <span><i class="fas fa-exclamation-triangle"></i>&nbsp;</span>
                    </ejs-tooltip>
                    <span [attr.aria-label]="name">{{name}}</span>
                </div>
            </ng-template>
        </ng-template>
    </ng-template>
</div>
